export default {
  finishAsParent: {
    margin: '0 0 10px'
  },
  finishAsIndividual: {
    margin: '10px 0'
  }
}
